import { LoadableLazy } from '@confluence/loadable';

export const PanelLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RightPanel" */ './RightPanel')).RightPanel,
});
